import { getOwsPath } from 'owa-config';
import getScopedPath from 'owa-url/lib/getScopedPath';

export function getStartupDataEndpoint(): string {
    return getScopedPath(getOwsPath()) + '/startupdata.ashx';
}
